import React from "react";
import styled, { keyframes } from "styled-components";
import { FaFileAlt, FaLaptopCode, FaChartBar } from "react-icons/fa";


const HowItWorks = () => {
  return (
    <Section>
      <Content>
        <Title>Jak to działa?</Title>
        <Steps>
          <Step delay="0s">
            <IconWrapper>
              <FaFileAlt />
            </IconWrapper>
            <StepTitle>Przygotuj plik JPK</StepTitle>
            <Description>
              Wygeneruj swój plik JPK VAT z systemu księgowego.
            </Description>
          </Step>

          <Arrow>→</Arrow>

          <Step delay="0.2s">
            <IconWrapper>
              <FaLaptopCode />
            </IconWrapper>
            <StepTitle>Zaimportuj plik</StepTitle>
            <Description>
              Prześlij plik do naszej platformy – analiza rozpocznie się automatycznie.
            </Description>
          </Step>

          <Arrow>→</Arrow>

          <Step delay="0.4s">
            <IconWrapper>
              <FaChartBar />
            </IconWrapper>
            <StepTitle>Uzyskaj analizy</StepTitle>
            <Description>
              Otrzymaj przejrzyste wykresy, raporty i rekomendacje dopasowane do Twojej firmy.
            </Description>
          </Step>
        </Steps>
      </Content>
    </Section>
  );
};

export default HowItWorks;

const ImageWrapper = styled.div`
  margin-top: 4rem;
  text-align: center;

  img {
    max-width: 100%;
    height: 50vh;
    border-radius: 12px;
  }
`;


const fadeUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const Section = styled.section`
  position: relative;
  padding: 2rem 2rem;
  background: url("/back.jpg") no-repeat center center fixed;
  background-size: cover;
  overflow: hidden;
`;


const Content = styled.div`
  position: relative;
  z-index: 1;
  text-align: center;
`;

const Title = styled.h2`
  font-size: 2.5rem;
  font-weight: bold;
  color: #1f2937;
  margin-bottom: 3rem;
`;

const Steps = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 2rem;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const Step = styled.div`
  background: white;
  border-radius: 15px;
  padding: 2rem;
  width: 260px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.05);
  animation: ${fadeUp} 0.6s ease-out forwards;
  opacity: 0;
  animation-delay: ${({ delay }) => delay || "0s"};
  animation-fill-mode: forwards;
`;

const IconWrapper = styled.div`
  font-size: 3rem;
  color: #3bc3cc;
  margin-bottom: 1rem;
  text-shadow: 0 0 10px rgba(59, 195, 204, 0.5);
`;

const StepTitle = styled.h3`
  font-size: 1.2rem;
  color: #111827;
  margin-bottom: 0.5rem;
  font-weight: bold;
`;

const Description = styled.p`
  font-size: 0.95rem;
  color: #6b7280;
`;

const Arrow = styled.div`
  font-size: 2rem;
  color: #3bc3cc;

  @media (max-width: 768px) {
    transform: rotate(90deg);
  }
`;
